/* eslint-disable react/no-unescaped-entities */
import MobileDetect from 'mobile-detect'
import React from 'react'
import Head from 'next/head'
import Hipporuber from '../src/components/Pages/Company/About/Hipporuber'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'

export default function hipporuberIndex(props) {
    return (
        <React.Fragment>
            <Head>
                <title>ООО "ГиппоРубер" - сеть аптек ЗДОРОВ.ру</title>
            </Head>
            {props.mobile && <MobileHeader>ООО "ГиппоРубер"</MobileHeader>}
            <Hipporuber isMobile={props.mobile} />
        </React.Fragment>
    )
}
export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    async customize({ context }) {
        const md = new MobileDetect(context.req.headers['user-agent'])
        return {
            props: {
                mobile: md.mobile()
            }
        }
    }
})
